import script from "./SupportView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportView.vue?vue&type=script&setup=true&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=6fda5bd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fda5bd8"]])

export default __exports__